import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

import indigo from '@material-ui/core/colors/indigo';
import { ConfirmDialog } from 'components/admin/Dialogs';

import { helpDispatch, Tooltip, TooltipTypes } from 'components/admin/Help';

import {
  Header,
  HeaderItem,
  Detail,
  Cogs,
  Expense,
  Rebill,
  ReceiptContent,
  Title,
} from './Dialog';

import {
  startAddReceipt,
  startEditReceipt,
  startRemoveReceipt
} from '../../../store/actions/receipts';

const styles = theme => ({
  rootContent: {
    backgroundColor: indigo[50],
  },
  title: {
    backgroundColor: indigo[800],
  },
  dialogActions: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  elevate: {
    zIndex: theme.zIndex.tooltipAction,
    backgroundColor: '#fff',
  },
});

const validate = (receipt) => {
  const errors = {};
  const requiredFields = [ 'tax', 'total', 'type', ];
  requiredFields.forEach(field => {
    if (!receipt[field]) {
      errors[field] = 'Required';
    }
  });

  if (receipt.type === "rebill" ) {
    if (!receipt.charged) {
      errors.charged = 'Required';
    }
    if (!receipt.clientId) {
      errors.clientId = 'Required';
    }
  }

  if (receipt.type === "cogs") {
    if (!receipt.clientId) {
      errors.clientId = 'Required';
    }
    if (!receipt.taxCategoryId) {
      errors.taxCategoryId = 'Required';
    }
  }

  if (receipt.type === "expense") {
    if (!receipt.taxCategoryId) {
      errors.taxCategoryId = 'Required';
    }
  }

  const validation = { errors, isInvalid: !!Object.keys(errors).length };
  validation.validateField = function (field) {
      return this.errors[field];
  };

  return validation;
}

class ReceiptDialog2 extends Component {
  constructor(props) {
    super(props);
    const { receiptData } = props;

    if (receiptData === undefined) {
      this.state = {
        receipt: {
          type: undefined,
          date: (new Date()).getTime(),
          tax: "",
          total: "",
          notes: "",
          markupPercent: 0,
          charged: 0,
        },
        showDelete: false,
      };
    } else {
      this.state = {
        receipt: {...receiptData},
        showDelete: false,
      };
    }

  }

  handleChange (propertyName, value) {
    this.setState(function(prevState, props){
      const { receipt, showValidation } = prevState;
      let validation;
      if (showValidation) {
        validation = validate({ ...receipt, [propertyName]: value });
      } else {
        validation = prevState.validation;
      }

      if (["total", "markupPercent", "charged"].includes(propertyName)) {
        let markupPercent = receipt.markupPercent === undefined ? 0 : receipt.markupPercent;
        let charged = receipt.charged === undefined ? 0 : receipt.charged;
        let total = receipt.total === undefined ? 0 : receipt.total;

        switch (propertyName) {
          case "total":
            total = value;
            charged = Number(total) + Number(((markupPercent/100)*total).toFixed(2));
            break;
          case "markupPercent":
            markupPercent = value;
            charged = Number(total) + Number(((markupPercent/100)*total).toFixed(2));
            break;
          case "charged":
            charged = value;
            markupPercent = (((charged - total)/total)*100).toFixed(0);
          default:
        }

        return {
          receipt: {
           ...prevState.receipt,
           charged: charged,
           total: total,
           markupPercent: markupPercent
         },
         validation,
        }
      } else {
        return {
          receipt: {
           ...prevState.receipt,
           [propertyName]: value,
           },
           validation,
        }
      }
    });
  }

  handleCancel = () => {
    this.setState({ showDelete: false });
  }

  handleDelete = () => {
    const { startRemoveReceipt, handleClose } = this.props;
    const { receipt } = this.state;

    startRemoveReceipt(receipt.id)
      .then(() => handleClose());
  }

  render() {
    const {
      classes,
      show,
      type,
      help,
      handleClose,
      startAddReceipt,
      startEditReceipt,
    } = this.props;
    const { receipt, showDelete, showValidation, validation } = this.state;

    return(
      <div>
        <ConfirmDialog
          open={showDelete}
          title="Delete Receipt"
          contentText="This action will delete the receipt. Proceed?"
          handleCancel={this.handleCancel}
          handleOk={this.handleDelete}
        />
        <Dialog
          maxWidth="md"
          open={show}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle className={classes.title}>
            <Title />
          </DialogTitle>
          <DialogContent classes={{root: classes.rootContent}}>
            <ReceiptContent
              showValidation={showValidation}
              validation={validation}
              receipt={receipt}
              handleChange={this.handleChange.bind(this)}
            />
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button onClick={() => this.setState({ showDelete: true })}>
              Delete
            </Button>
            <div>
              <Button onClick={handleClose} color="primary">
                Cancel
              </Button>
              <Tooltip type={TooltipTypes.receipt.SAVE_DIALOG} placement="right">
                <Button
                  onClick={() => {
                    const validation = validate(receipt);
                    if (validation.isInvalid) {
                      this.setState({
                        showValidation: true,
                        validation,
                      });
                    } else {
                      if (type === "add") {
                        startAddReceipt(receipt)
                          .then(() => {
                            helpDispatch(TooltipTypes.receipt.SAVE_DIALOG);
                            handleClose();
                          });
                      } else {
                        const { id, ...updates } = receipt;
                        startEditReceipt(id, updates)
                          .then(() => handleClose())
                      }
                    }

                  }}
                  color="primary">
                  {type === "add" ? "Add" : "Done"}
                </Button>
              </Tooltip>
            </div>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  help: state.help,
});

const mapDispatchToProps = {
  startAddReceipt,
  startEditReceipt,
  startRemoveReceipt,
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(ReceiptDialog2);
//export default connect(null, mapDispatchToProps)(ReceiptDialog2);



// WEBPACK FOOTER //
// ./src/components/admin/Receipts/ReceiptDialog2.jsx